import { ModalMessagerService } from './../../dialogs/modal-messager/modal-messager.service';
import { Preset, PresetType } from './../../../types/project-config';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Project } from 'app/model/project';
import { IDKeyTypes, ObjID } from 'app/model/id-manager';

@Component({
  selector: 'app-preset-listing',
  templateUrl: './preset-listing.component.html',
  styleUrls: ['./preset-listing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PresetListingComponent implements OnInit {

  private _ready = false;

  private _project?: Project;
  @Input()
  public set project(prj: Project | undefined) {
    this._project = prj;
    this.Refresh();
  }
  public get project(): Project | undefined {
    return this._project;
  }

  private _selectedType: PresetType | '' = '';
  public set selectedType(type: PresetType | '') {
    this._selectedType = type;
    this.Refresh();
  }
  public get selectedType(): PresetType | '' {
    return this._selectedType;
  }
  public get showingPoints(): boolean {
    return this._selectedType === 'point';
  }
  public get showingSegments(): boolean {
    return this._selectedType === 'segment';
  }

  public get ptPresets(): Array<Preset> {
    if (!(this._project && this._project.config && this._project.config.presets && this._project.config.presets.point)) {
      return [];
    }
    return this._project.config.presets.point;
  }
  public get segmentPresets() {
    if (!(this._project && this._project.config && this._project.config.presets && this._project.config.presets.segment)) {
      return [];
    }
    return this._project.config.presets.segment;

  }

  @Output()
  public presetSelected = new EventEmitter<Preset>();
  constructor(private cdr: ChangeDetectorRef, private messager: ModalMessagerService) { }

  ngOnInit(): void {
    this._ready = true;
  }
  HasPresets(): boolean {
    return (this.project && this.project.config && !!this.project.config.presets) ? true : false;
  }
  Add() {
    if (this.selectedType === '') {
      this.messager.Notify('Please select a preset type to continue');
      return;
    }
    if (!(this._project && this._project.config)) return;
    if (!(this._project && this._project.config && this._project.config.presets && this._project.config.presets[this.selectedType])) {
      this._project.config.presets[this.selectedType] = [];
    }
    let id: ObjID = 0;
    switch (this.selectedType) {
      case 'point':
        id = this._project.idManager.ID(IDKeyTypes.PointPreset) as number;
        break;
      case 'segment':
        id = this._project.idManager.ID(IDKeyTypes.SegmentPreset) as number;
    }
    const preset:Preset = {
      id: (id),
      data:{},
      label:`New ${this.selectedType} preset`
    };
    const presets = this._project.config.presets[this.selectedType] as Array<Preset>;
    presets.push(preset);
    this._project.idRegistry.RegisterID(id,preset);
    this.Refresh();
  }
  Refresh() {
    if (!this._ready) return;
    this.cdr.detectChanges();
  }
  Select(preset:Preset) {
    this.presetSelected.emit(preset);
  }

}
